export default __webpack_public_path__ + "static/media/bg.56746980.png";